import { lazy } from "react";

export { CANDIDATE_PATH } from "./path";
export const CandidatePage = lazy(() => import("./page"));
